import e, { Component as t } from "react";
import { CheckBoxStateful as r } from "./CheckboxStateful.js";
import { CheckBoxStateless as n } from "./CheckboxStateless.js";
function o(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function c(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function u(e) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function f(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
      n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), n.forEach(function (t) {
      c(e, t, r[t]);
    });
  }
  return e;
}
function i(e, t) {
  return (i = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var l = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && i(e, t);
  }(p, t);
  var c,
    l,
    a,
    s = (c = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = u(p);
      if (c) {
        var n = u(this).constructor;
        t = Reflect.construct(r, arguments, n);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : function (e) {
        if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(this);
    });
  function p() {
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, p), s.apply(this, arguments);
  }
  return l = [{
    key: "render",
    value: function value() {
      var t = this.props,
        o = t.stateful,
        c = function (e, t) {
          if (null == e) return {};
          var r,
            n,
            o = function (e, t) {
              if (null == e) return {};
              var r,
                n,
                o = {},
                c = Object.keys(e);
              for (n = 0; n < c.length; n++) r = c[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var c = Object.getOwnPropertySymbols(e);
            for (n = 0; n < c.length; n++) r = c[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
          }
          return o;
        }(t, ["stateful"]);
      return o ? e.createElement(r, f({
        ref: "stateful"
      }, c)) : e.createElement(n, f({
        ref: "stateless"
      }, c));
    }
  }], o(p.prototype, l), a && o(p, a), p;
}(t);
c(l, "displayName", "FormCheckField"), c(l, "defaultProps", {
  stateful: !1
});
export { l as CheckBox };